module.exports = __webpack_public_path__ + "static/img/navIcon.d02051ed.png";